/**
 * Formata um CNPJ (14 dígitos) como `00.000.000/0000-00`.
 * Se o valor não tiver exatamente 14 dígitos (ex.: CPF, dado incompleto),
 * retorna o valor original sem alteração — nunca lança nem inventa dígitos.
 */
export function formatCnpj(value: string | null | undefined): string | undefined {
  if (!value) return undefined;
  const digits = value.replace(/\D/g, '');
  if (digits.length !== 14) return value;
  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12, 14)}`;
}
